// src/features/checklist/ChecklistModal.jsx
import React from "react";


export default function ChecklistModal({
  open,
  onClose,
  items,
  values,
  visibility,
  showHidden,
  setShowHidden,
  loadingItems,
  loadingSaved,
  visBusySlug,
  setValue,
  setItemVisibility,
  onSave,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-3xl rounded shadow p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-lg font-semibold">Sjekkliste</h4>
          <div className="flex items-center gap-3">
            <label className="text-sm flex items-center gap-2">
              <input
                type="checkbox"
                checked={showHidden}
                onChange={(e) => setShowHidden(e.target.checked)}
              />
              Vis skjulte punkter
            </label>
            <button onClick={onClose} className="text-gray-600 hover:text-black">
              Lukk
            </button>
          </div>
        </div>

        {loadingItems || loadingSaved ? (
          <div className="py-8 text-center">Henter sjekkliste…</div>
        ) : items.length ? (
          <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-1">
            {items
              .filter((it) =>
                showHidden ? true : visibility[it.punktSlug] !== false
              )
              .map((it) => {
                const val = values[it.punktSlug] || {};
                const isVisible = visibility[it.punktSlug] !== false;

                const untreated =
                  isVisible &&
                  !val.okValue &&
                  !val.doneValue &&
                  !val.avvikValue &&
                  !(val.commentValue || "").trim();

                return (
                  <div
                    key={it.punktSlug}
                    className={`border rounded p-3 ${
                      isVisible ? "" : "opacity-60 bg-gray-50"
                    } ${untreated ? "bg-amber-50" : ""}`}
                  >
                    <div className="flex items-start justify-between gap-3 mb-2">
                      <div className="font-medium">{it.tittel}</div>
                      <div className="flex items-center gap-2">
                        {isVisible ? (
                          <button
                            disabled={visBusySlug === it.punktSlug}
                            onClick={() => setItemVisibility(it.punktSlug, false)}
                            className="text-xs px-2 py-1 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50"
                            title="Skjul fra denne tjenesten"
                          >
                            {visBusySlug === it.punktSlug ? "Skjuler…" : "Skjul"}
                          </button>
                        ) : (
                          <button
                            disabled={visBusySlug === it.punktSlug}
                            onClick={() => setItemVisibility(it.punktSlug, true)}
                            className="text-xs px-2 py-1 rounded border border-emerald-300 text-emerald-700 hover:bg-emerald-50 disabled:opacity-50"
                            title="Vis igjen i denne tjenesten"
                          >
                            {visBusySlug === it.punktSlug ? "Viser…" : "Vis igjen"}
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-4">
                      {it.visOk && (
                        <label className="inline-flex items-center gap-2">
                          <input
                            type="checkbox"
                            checked={!!val.okValue}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              // OK og Utbedres kan ikke være samtidig
                              setValue(it.punktSlug, {
                                okValue: checked,
                                doneValue: checked ? false : val.doneValue,
                              });
                            }}
                            disabled={!isVisible}
                          />
                          <span>OK</span>
                        </label>
                      )}

{it.visUtfort && (
  <label className="inline-flex items-center gap-2">
    <input
      type="checkbox"
      checked={!!val.doneValue}
      onChange={(e) => {
        const checked = e.target.checked;
        // Utføres og OK kan ikke være samtidig
        setValue(it.punktSlug, {
          doneValue: checked,
          okValue: checked ? false : val.okValue,
        });
      }}
      disabled={!isVisible}
    />
    <span>Utføres</span>
  </label>
)}


                      {/* Kommentar: ALLTID tilgjengelig */}
                      <div className="flex-1 min-w-[220px]">
                        <input
                          type="text"
                          className="w-full border rounded p-2 text-sm"
                          placeholder="Kommentar"
                          value={val.commentValue || ""}
                          onChange={(e) =>
                            setValue(it.punktSlug, {
                              commentValue: e.target.value,
                            })
                          }
                          disabled={!isVisible}
                        />
                      </div>

                      {/* Avvik: styres av visUtfort */}
                      {it.visUtfort && (
                        <label className="inline-flex items-center gap-2 text-sm">
                          <input
                            type="checkbox"
                            checked={!!val.avvikValue}
                            onChange={(e) =>
                              setValue(it.punktSlug, {
                                avvikValue: e.target.checked,
                              })
                            }
                            disabled={!isVisible}
                          />
                          <span>Avvik</span>
                        </label>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="py-8 text-center text-gray-600">
            Ingen sjekkliste er koblet til disse tjenestene.
          </div>
        )}

        <div className="mt-4 flex items-center justify-end gap-2">
          <button className="px-3 py-1 rounded border" onClick={onClose}>
            Avbryt
          </button>
          <button
            className="px-3 py-1 rounded text-white bg-emerald-600 hover:bg-emerald-700"
            onClick={onSave}
          >
            Lagre
          </button>
        </div>
      </div>
    </div>
  );
}

